
import { useEffect, useState, useRef } from 'react';

export default function Commitment() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const commitments = [
    {
      text: 'We built ephemeral processing so data cannot be breached',
      highlight: 'it doesn\'t exist',
    },
    {
      text: 'We built zero retention so data cannot be subpoenaed',
      highlight: 'we don\'t have it',
    },
    {
      text: 'We built local caching so client info never touches our servers',
      highlight: '',
    },
  ];

  return (
    <section ref={sectionRef} className="relative py-24 bg-[#09090b]">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <h2 className="text-white text-3xl sm:text-[42px] font-black text-center mb-16 sm:mb-20">
          Our Commitment
        </h2>

        <div className="max-w-[900px] mx-auto space-y-8 sm:space-y-12">
          {commitments.map((commitment, index) => (
            <div
              key={index}
              className={`p-6 sm:p-8 bg-[#0f0f11] border border-[#1a1a1c] rounded-xl transition-all duration-700 hover:border-[#06b6d4] hover:shadow-[0_0_30px_rgba(6,182,212,0.15)] ${
                animated ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
              }`}
              style={{ transitionDelay: `${index * 200}ms` }}
            >
              <p className="text-[#d4d4d8] text-lg sm:text-xl leading-relaxed">
                {commitment.text}
                {commitment.highlight && (
                  <>
                    {' — '}
                    <span className="text-[#06b6d4] font-bold">
                      {commitment.highlight}
                    </span>
                  </>
                )}
              </p>
            </div>
          ))}

          <p
            className={`text-white text-2xl sm:text-3xl font-black text-center pt-8 transition-all duration-700 delay-600 ${
              animated ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
            }`}
          >
            Your privilege. Your data. Protected
          </p>
        </div>
      </div>
    </section>
  );
}
